module.exports = __webpack_public_path__ + "assets/e99a548cb5cb7c359e012952e5a856d6.mp3";